const CLICKABLE_TOAST_CLASS_PREFIX = 'phoebe-clickable-toast--';

const clickableToastHandlers = new Map<string, () => void>();
let nextClickableToastInstanceId = 0;

export function buildClickableToastClassName(id: string): string {
    const encodedId = Array.from(id)
        .map((character) => {
            const codePoint = character.codePointAt(0);
            if (codePoint === undefined) {
                throw new Error('Toast id contained an invalid character');
            }

            return codePoint.toString(16).padStart(6, '0');
        })
        .join('-');

    return `${CLICKABLE_TOAST_CLASS_PREFIX}${encodedId}`;
}

export function createClickableToastClassName(notificationId: string): string {
    nextClickableToastInstanceId += 1;

    return buildClickableToastClassName(
        `${notificationId}:${nextClickableToastInstanceId}`,
    );
}

export function registerClickableToast(
    className: string,
    onClick: () => void,
): void {
    clickableToastHandlers.set(className, onClick);
}

export function unregisterClickableToast(className: string): void {
    clickableToastHandlers.delete(className);
}

export function getClickableToastHandlerForTarget(
    target: EventTarget | null,
): (() => void) | null {
    if (!(target instanceof Element)) {
        return null;
    }

    const toastElement = target.closest('[data-sonner-toast]');
    if (!(toastElement instanceof HTMLElement)) {
        return null;
    }

    const clickableToastClassName = Array.from(toastElement.classList).find(
        (className) => className.startsWith(CLICKABLE_TOAST_CLASS_PREFIX),
    );

    if (clickableToastClassName === undefined) {
        return null;
    }

    return clickableToastHandlers.get(clickableToastClassName) ?? null;
}
